/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/whats_app/message_templates/:external_account_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdWhatsAppMessageTemplatesExternalAccountId } from "./constants";
import type { GetEngagementAppGroupIdWhatsAppMessageTemplatesExternalAccountIdResult } from "./types";
import { isGetEngagementAppGroupIdWhatsAppMessageTemplatesExternalAccountIdResult } from "./validators";

export const getEngagementAppGroupIdWhatsAppMessageTemplatesExternalAccountId = reactQueryFetcherAdapter(
  engagementAppGroupIdWhatsAppMessageTemplatesExternalAccountId,
  (
    signal: AbortSignal,
    appGroupId: string,
    externalAccountId: string,
    queryParams: { name?: string; language?: string }
  ): Promise<GetEngagementAppGroupIdWhatsAppMessageTemplatesExternalAccountIdResult> => {
    return fetch(`/engagement/${appGroupId}/whats_app/message_templates/${externalAccountId}`, "GET", queryParams, {
      signal,
    });
  },
  isGetEngagementAppGroupIdWhatsAppMessageTemplatesExternalAccountIdResult
);
